// extracted by mini-css-extract-plugin
module.exports = {"tabList":"style_tabList__Oc_Vi","categorySection":"style_categorySection__3A5MJ"};